module.exports = __webpack_public_path__ + "static/media/stakla.b6ddd8b4.png";